import { api } from '../../DefaultService';
import { IPaginationParams } from '../../types';
import { INotificationLogResponse, INotificationLogFilterParams } from './types';

const ENDPOINT = 'v1/logs/notifications';

const buildFilterParams = (filter?: INotificationLogFilterParams, pagination?: IPaginationParams) => {
  const params = new URLSearchParams();

  if (pagination) {
    Object.entries(pagination).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, value.toString());
      }
    });
  }

  if (filter?.platforms && filter.platforms.length > 0) {
    filter.platforms.forEach(platform => {
      params.append('platforms', platform);
    });
  }

  if (filter?.isSuccess !== undefined) {
    params.append('isSuccess', String(filter.isSuccess));
  }

  if (filter?.startDate) {
    params.append('startDate', filter.startDate);
  }

  if (filter?.endDate) {
    params.append('endDate', filter.endDate);
  }

  return params;
};

export const getAllNotificationLogsByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: INotificationLogFilterParams
): Promise<INotificationLogResponse[]> => {
  const params = buildFilterParams(filter, pagination);
  const response = await api.get(`${ENDPOINT}/getAllByLicense`, { params });
  return response.data;
};

export const getNotificationLogsCountAsync = async (
  filter: INotificationLogFilterParams
): Promise<number> => {
  const params = buildFilterParams(filter);
  const response = await api.get(`${ENDPOINT}/getAllByLicense/count`, { params });
  return response.data;
};